import React from "react";
import infoConstants from "../../../shared/infoConstants";
import HBIconLoginSvg from "../../../assets/images/healthbeacon.svg";
import pharmacareLoginSvg from "../../../assets/images/pharmacare.svg";

export const SupportText = ({
  className = "",
  className2 = "",
  className3 = "",
  showLogos,
}) => {
  return (
    <div className={className} data-testid="footer-support">
      <div>
        {showLogos && (
          <>
            <div className={className3} data-testid="footer-support-logos">
              <img src={HBIconLoginSvg} alt="HB Logo" />
              <img src={pharmacareLoginSvg} alt="Pharmacare Logo" />
            </div>
            <p className="text-below-logos">
              <b> Please contact below if you wish to request a user guide</b>
            </p>
          </>
        )}
      </div>
      <span className={`${className2} text-align-center mb-1 `}>
        For support, contact Pharmacare Group at
        <a
          href={`tel:${infoConstants.nhsPhoneNumber}`}
          data-testid="footer-support-phone"
        >
          <b> {infoConstants.nhsPhoneNumber}</b>
        </a>
        , or email
        <a
          href={`mailto: ${infoConstants.nhsEmail}`}
          data-testid="footer-support-email"
        >
          <b> {infoConstants.nhsEmail}</b>
        </a>
      </span>
    </div>
  );
};
